import React from "react";
import _ from "lodash";
import { DateTime } from "luxon";
import { PositionedOverlayComponent } from "./Mixins";
export class DateSelectionPaneComponent extends PositionedOverlayComponent {
    constructor(props) {
        super(props);
        this.state = {
            selectedDt: this.props.selectedDt,
            startDt: this.props.selectedDt.startOf("month"),
            validDates: undefined,
        };
    }
    static getDerivedStateFromProps(props, state) {
        return {
            selectedDt: props.selectedDt,
            startDt: state.selectedDt.toMillis() === props.selectedDt.toMillis() ? state.startDt : props.selectedDt.startOf("month"),
        };
    }
    componentDidMount() {
        this.createOverlay();
    }
    componentWillUnmount() {
        this.disposeOverlay();
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.startDt.toMillis() !== prevState.startDt.toMillis() || typeof this.state.validDates === "undefined") {
            this.props.onShow(this.state.startDt.startOf("week"), this.state.startDt.endOf("month").endOf("week").startOf("day")).then((result) => {
                this.setState({ validDates: result });
            });
        }
    }
    constructRows() {
        let dt = this.state.startDt.startOf("week");
        let endDt = this.state.startDt.endOf("month").endOf("week").plus({ days: 1 }).startOf("day");
        if (endDt.weekday !== 1) {
            endDt = endDt.plus({ days: 8 - endDt.weekday });
        }
        let rows = [];
        while (dt.toMillis() < endDt.toMillis()) {
            let row = rows.find(x => x.weekNumber === dt.weekNumber);
            if (!row) {
                row = { weekNumber: dt.weekNumber, weekDisplay: dt.toFormat("WW"), days: [] };
                rows.push(row);
            }
            row.days.push({
                dt: dt,
                day: dt.toFormat("dd"),
                ordinal: dt.toMillis(),
                isCurrentMonth: dt.month === this.state.startDt.month,
                isToday: dt.toISODate() === DateTime.now().toISODate(),
                isSelected: dt.toISODate() === this.state.selectedDt.toISODate()
            });
            dt = dt.plus({ days: 1 });
        }
        return rows;
    }
    select(day) {
        this.hideOverlay();
        this.setState({ selectedDt: day.dt });
        !!this.props.onSelected && this.props.onSelected(day.dt);
    }
    toOrigin() {
        this.setState({ startDt: this.props.selectedDt.startOf("month") });
    }
    toToday() {
        this.setState({ startDt: DateTime.now().startOf("month") });
    }
    navigate(increment) {
        this.setState({ startDt: this.state.startDt.plus({ months: increment }) });
    }
    render() {
        !!this.props.shown && this.showOverlay();
        const rows = this.constructRows();
        let flatten = rows.reduce((acc, val) => acc.concat(val.days), []);
        flatten.sort((a, b) => a.ordinal - b.ordinal);
        let validDt = !!this.state.validDates ? this.state.validDates : flatten;
        const dayCols = _.range(0, 7);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { ref: this.positionPane.bind(this), className: "ds-pane", role: "dialog", "aria-label": "V\u00E6lg dato", tabIndex: -1, style: { display: (!this.props.shown) ? "none" : "flex" } },
                React.createElement("div", { className: "ds-pane-navigation" },
                    React.createElement("button", { type: "button", className: "btn btn-transparent", "aria-label": "Forrige m\u00E5ned", onClick: () => this.navigate(-1) },
                        React.createElement("i", { className: "fa-regular fa-less-than no-text", "aria-hidden": "true" })),
                    React.createElement("span", null, this.state.startDt.toFormat("MMMM yyyy")),
                    React.createElement("span", null,
                        React.createElement("button", { type: "button", className: "btn btn-transparent", "aria-label": "I dag", onClick: () => this.toToday() },
                            React.createElement("i", { className: "fa-regular fa-calendar no-text", "aria-hidden": "true" })),
                        React.createElement("button", { type: "button", className: "btn btn-transparent", "aria-label": "Det valgte", onClick: () => this.toOrigin() },
                            React.createElement("i", { className: "fa-regular fa-circle-dot no-text", "aria-hidden": "true" })),
                        React.createElement("button", { type: "button", className: "btn btn-transparent", "aria-label": "N\u00E6ste m\u00E5ned", onClick: () => this.navigate(1) },
                            React.createElement("i", { className: "fa-regular fa-greater-than no-text", "aria-hidden": "true" })))),
                React.createElement("div", { className: "ds-pane-dates" },
                    React.createElement("div", { className: "ds-pane-headers" },
                        React.createElement("div", { className: "ds-pane-row-header" },
                            React.createElement("span", null, "Uge")),
                        React.createElement("div", { className: "ds-pane-row-header-inner" }, rows.map((row, rowidx) => React.createElement("div", { key: `week-${rowidx}`, className: "ds-pane-row-header" },
                            React.createElement("span", null, row.weekDisplay))))),
                    dayCols.map((col, colidx) => {
                        return (React.createElement("div", { className: "ds-pane-dates-col", key: `col-${colidx}` },
                            React.createElement("div", { className: "ds-pane-datecol-header" },
                                React.createElement("span", null, rows[0].days[col].dt.toFormat("ccccc"))),
                            rows.map((row, rowidx) => {
                                const day = row.days[col];
                                const selected = day.isSelected ? ' selected-date' : '';
                                const current = day.isToday ? ' current-date' : '';
                                const currentMonth = !day.isCurrentMonth ? ' past-date' : '';
                                const valid = validDt.includes(day.dt.toFormat("yyyy-MM-dd"));
                                const validDay = valid ? '' : ' invalid-date';
                                return (React.createElement("button", { type: "button", className: `ds-pane-datecol-date${selected}${current}${currentMonth}${validDay}`, key: `day-${rowidx}-${colidx}`, disabled: !valid, "aria-label": day.dt.toFormat("cccc d. MMMM yyyy"), "aria-pressed": day.isSelected, "aria-current": day.isToday ? "date" : undefined, onClick: () => valid && this.select(day) },
                                    React.createElement("span", { "aria-hidden": "true" }, day.day)));
                            })));
                    })))));
    }
}
